module.exports = __webpack_public_path__ + "static/media/icon-navbar-Creative-demo.dee801df.png";